<app-nav></app-nav>

<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<main class="page" *ngIf="!isLoading">

  <!-- HERO -->
  <section class="hero">
    <div class="hero-bg" style="background-image: url('assets/cards/hero-bg.jpg')"></div>

    <div class="hero-text">
      <h1>My <span>Cards</span></h1>
      <p>Create, manage and share your digital cards. One card. Unlimited opportunities.</p>
    </div>

    <div class="hero-quote">Your Card<br />Your Story<br />Your Impact</div>

    <div class="hero-actions">
      <a routerLink="/create-card" class="btn-pink big"><i class="fa-solid fa-plus"></i> Create New Card</a>
      <button type="button" class="btn-ghost" id="upgrade"
              data-bs-toggle="modal" data-bs-target="#upgradePackages" (click)="openPackageModal()">
        <i class="fa-solid fa-arrow-up-short-wide"></i> Upgrade Package
      </button>
      <button type="button" class="btn-ghost" *ngIf="userData?.package_id == digitalCardPackageId" (click)="goToRadio()">
        <i class="fa-solid fa-broadcast-tower"></i> Radio Dashboard
      </button>
    </div>
  </section>

  <!-- STATS -->
  <section class="stats">
    <div class="stat">
      <div class="stat-ico"><i class="fa-regular fa-id-card"></i></div>
      <div><span>Total Cards</span><b>{{ cards?.length || 0 }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-eye"></i></div>
      <div><span>Total Views</span><b>{{ totalViews }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-share-nodes"></i></div>
      <div><span>Total Shares</span><b>{{ totalShares }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-user-group"></i></div>
      <div><span>Total Contacts</span><b>{{ totalContacts }}</b></div>
    </div>
  </section>

  <!-- TOOLBAR -->
  <section class="toolbar">
    <div class="tabs"><span class="tab active">All Cards ({{ cards?.length || 0 }})</span></div>

    <div class="tools">
      <div class="t-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="search" placeholder="Search your cards..." [(ngModel)]="searchText" (ngModelChange)="resetPaging()" name="cardSearch" autocomplete="off" />
      </div>
      <div class="t-sort">
        <i class="fa-solid fa-arrow-down-wide-short"></i>
        <select [(ngModel)]="sortBy" (ngModelChange)="resetPaging()" name="cardSort">
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="views">Most Views</option>
          <option value="shares">Most Shares</option>
        </select>
      </div>
    </div>
  </section>

  <!-- CARDS GRID -->
  <section class="grid">
    <article class="c-card" *ngFor="let card of visibleCards; trackBy: trackByCardId">

      <button type="button" class="dots" (click)="toggleDots(card.id, $event)">
        <i class="fa-solid fa-ellipsis-vertical"></i>
      </button>
      <ul class="dots-menu" *ngIf="activeCardId === card.id">
        <li (click)="generateQr(card.id)"><i class="fa-solid fa-floppy-disk"></i> Download QR</li>
        <li class="danger" (click)="deleteCard(card.id)"><i class="fa-solid fa-trash"></i> Delete</li>
      </ul>

      <div class="thumb" [style.backgroundImage]="'url(' + (card.change_photo || 'assets/images/avatar.png') + ')'"></div>

      <h3 class="c-name">{{ card.infoFormData?.firstName + ' ' + card.infoFormData?.lastName }}</h3>
      <p class="c-title">{{ card.infoFormData?.cardTitle }}</p>

      <div class="c-stats">
        <span><i class="fa-solid fa-eye"></i> {{ card.totalViews || 0 }}</span>
        <span><i class="fa-solid fa-share-nodes"></i> {{ card.sends || 0 }}</span>
      </div>

      <div class="c-actions">
        <a class="b-outline" routerLink="/cards/preview-card/{{ card.id }}">View</a>
        <button type="button" class="b-pink" data-bs-toggle="modal" data-bs-target="#shareCard" (click)="setShareCard(card.id)">Share</button>
        <a class="b-outline" routerLink="/edit-card/{{ card.id }}">Edit</a>
      </div>
    </article>
  </section>

  <!-- LOAD MORE -->
  <div class="load-more-wrap" *ngIf="hasMoreCards" style="text-align: center; margin: 22px 0">
    <button type="button" class="btn-pink" (click)="loadMore()">
      <i class="fa-solid fa-angles-down"></i> Load More ({{ filteredCards.length - visibleCount }} more)
    </button>
  </div>

  <p class="empty" *ngIf="cards && filteredCards.length === 0">You haven't created any cards yet.</p>

  <!-- CREATE ANOTHER -->
  <a routerLink="/create-card" class="create-another">
    <span class="plus"><i class="fa-solid fa-plus"></i></span>
    <div>
      <b>Create Another Card</b>
      <small>Build a new card for your business, brand, event, organization or personal use.</small>
    </div>
  </a>

  <div class="tagline">“More Than A Card, A Movement.”</div>
</main>

<div
  class="modal fade"
  id="shareCard"
  tabindex="-1"
  aria-labelledby="shareCardLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="shareCardLabel">Share Card</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="row"
          style="
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            justify-content: center;
          "
        >
          <h5 (copy)="incrementCardSend(shareCardId)"
          style="width: 100%; text-align: center; padding-bottom: 25px">
            https://umyogossip.site/cards/share-card/{{ shareCardId }}
          </h5>
          <button
            class="btn btn-primary"
            style="width: 80%; text-align: center; padding-bottom: 15px"
            (click)="openShareDialog()"
          >
            Share
          </button>
          <h3
            style="
              width: 100%;
              text-align: center;
              padding-bottom: 25px;
              padding-top: 40px;
              font-size: medium;
            "
          >
            Copy link to share your card.
          </h3>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>


<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ loadingTitle }}</h3>
          <p style="padding-top: 15px">{{ loadingMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close" (click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div
              class="outerCard"
              style="min-height: 30vh; cursor: pointer"
              *ngIf="package.price !== '0'"
            >
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->

          <!-- hide stripe  -->

          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button>
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="payWithPayPal(selectedPackage)"
          >
            paypal
          </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <h3>
            Amount
            {{ selectedPackage?.net_price ? selectedPackage?.net_price : selectedPackage?.price }}
          </h3>
           <div class="row" ngxStripeCardGroup>

            <div class="col-md-12" style="padding-top: 17px">
              <label style="font-size:17px; font-weight:600; padding-bottom:8px;">Card Number</label>
              <div style="border:1px solid #ced4da; border-radius:4px; padding:10px;">
                <ngx-stripe-card-number [options]="cardOptions"></ngx-stripe-card-number>
              </div>
            </div>

            <div class="col-md-6" style="padding-top: 17px">
              <label style="font-size:17px; font-weight:600; padding-bottom:8px;">Expiry Date</label>
              <div style="border:1px solid #ced4da; border-radius:4px; padding:10px;">
                <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
              </div>
            </div>

            <div class="col-md-6" style="padding-top: 17px">
              <label style="font-size:17px; font-weight:600; padding-bottom:8px;">CVC</label>
              <div style="border:1px solid #ced4da; border-radius:4px; padding:10px;">
                <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
              </div>
            </div>

          </div>
          <div class="row mt-3">
            <div class="col-md-12" style="display:flex; justify-content:center; padding-top:10px;">
              <button type="button" class="btn btn-primary" (click)="pay()">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>